"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _ = require("lodash");
class ValidationForms {
    static sliceAfterOf(text, index) {
        let textResponse = _.cloneDeep(text);
        return textResponse.length > index ? textResponse.slice(0, textResponse.length - 1) : textResponse;
    }
    static onlyNumbersPass(value) {
        let responseValue = _.cloneDeep(value);
        const lastChar = responseValue.charAt(responseValue.length - 1);
        responseValue = responseValue.slice(0, responseValue.length - 1);
        if (!isNaN(+lastChar)) {
            responseValue += lastChar;
        }
        return responseValue;
    }
    static onlyTextPass(value) {
        return value.replace(/[^\w\s-]/gi, '');
    }
    static textAndCharacterSpecialPass(value) {
        if (!/^[​​​​​a-zA-Z0-9 ./#:,/()-]+$/.test(value)) {
            return value.replace(value[value.length - 1], '');
        }
        return value;
    }
}
exports.ValidationForms = ValidationForms;
//# sourceMappingURL=ValidationForms.js.map